import { useContext } from "react";
import { AppContext } from "../App";
import { formatDate, formatMoney } from "../Helpers";

export default function OnePaymentRecord({ data }) {

  const appContext = useContext(AppContext);

  const title = appContext.language === "sw"
    ? data.titleSw || data.titleEn
    : data.titleEn;
  const isDanger = [
    "failed",
    "rejected",
    "reversed",
    "cancelled",
    "expired",
  ].includes(data.status);

  function openPayment() {
    appContext.navTo({
      item: "side-view",
      subItem: "payment-record-options",
      extraItem: data.uuid,
    })
  }

  function getStatusClass() {
    if (data.status === "successful") {
      return "bg-success";
    }

    if (isDanger) {
      return "bg-danger";
    }

    return "bg-dark";
  }

  return (
    <div
      className="card mb-2"
      onClick={openPayment}
      style={{ cursor: "pointer" }}
    >
      <div className="card-body d-flex justify-content-between align-items-start">
        <div>
          <h6 className="font-semi-bold mb-1">
            {title || "Service payment"}
          </h6>
          <small className="text-muted d-block">
            {String(data.paymentMethod || "").replaceAll("_", " ")}
          </small>
          <small className="text-muted">
            {formatDate(data.dateCreated)}
          </small>
        </div>
        <div className="text-end">
          <h6 className="font-bold text-primary mb-1">
            TZS {formatMoney(data.amount)}
          </h6>
          <span className={`badge ${getStatusClass()}`}>
            {data.status}
          </span>
        </div>
      </div>
    </div>
  );
}
